import { Component, OnInit } from '@angular/core';
import { PostRegisterFooterComponent } from '../shared/post-register-footer.component';
import { FormatTimePipe } from '../helpers/pipe/format-time.pipe';
import { CommonModule } from '@angular/common';

@Component({
  selector: "app-failed-credit-score",
  templateUrl: "./failed-credit-score.component.html",
  styleUrls: ["./failed-credit-score.component.css"],
  standalone: true,
  imports: [PostRegisterFooterComponent,CommonModule]
})
export class FailedCreditScoreComponent implements OnInit {
  errorMsg = "We could not complete your registration.";

  constructor() {}

  ngOnInit(): void {}
}
